import { Tabs, TabsProps } from 'antd';
import { Loader } from '../../../common/components/Loader/Loader'
import { TitleHeader } from '../../../common/components/TitleHeader/TitleHeader'
import { Container } from '../../../common/components/container/Container'
import { MainCadence } from './components/MainCadence';
import { CustomizedCadence } from './components/CustomizedCadence';
import { useSearchParams } from 'react-router';

export const Schedules = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentType = searchParams.get("type") || "main";
  const items: TabsProps['items'] = [
      {
        key: 'main',
        label: 'Cadence générale',
        children: <MainCadence currentType={currentType}/>,
      },
      {
        key: 'customized',
        label: 'Cadence personnalisée',
        children: <CustomizedCadence currentType={currentType}/>,
      },
    ];

  return (
    <>
    <Loader /* isLoading={isLoading} */ />
          <TitleHeader
            title="Cadences"
          />
    <Container>
    <Tabs activeKey={currentType} items={items} onChange={(key) => {
            setSearchParams({ type: key });
          }} />
    </Container>
    </>
  )
}
